import CustomButton from '../../../../components/customFormControls/button/Button'
import { Sizes } from '../../../../types'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PATHS } from '../../../../routes/Routes'

const AddDuplicateFileSetup = () => {
  const navigate = useNavigate()
  const handleAddNew = () => {
    navigate(PATHS.DUPLICATE_CREATE_SETUP)
  }
  return (
    <>
      <div className='action'>
        <CustomButton
          onClick={handleAddNew}
          size={Sizes.Medium}
          variant='secondary'
          icon='ki-plus'
          label='Create Setup'
        ></CustomButton>
      </div>
    </>
  )
}
export default AddDuplicateFileSetup
